const StorRequiredInternalFields = {
    // ordineOperazione: {
    //     descrStrumFinanziario: ["codiceIdentificativo"]
    // }
}

export default StorRequiredInternalFields
